




















import { Image, List } from 'vant';
import { Component, Prop, Vue } from "vue-property-decorator";
import { ErrorCode, ErrorInfo, RequestState } from "@/network/http";
import { formatMessage } from "@/locale";
import { ArchivesList, ArchivesInfo } from "@/data/local/archives";
import ArchivesItem from "@/components/ArchivesItem.vue";

Vue.use(Image);
Vue.use(List);

@Component({
    components: {
        "v-archives-item": ArchivesItem,
    }
})
export default class MainArchives extends Vue {
    showList: boolean = true;
    pageNo: number = 1;
    pageSize: number = process.env.VUE_APP_DEFAULT_PAGE_SIZE;
    errorMsg: string = "";
    immCheck: boolean = true;
    listLoading: boolean = false;
    listFinished: boolean = false;
    listLoadError: boolean = false;
    listLoadingText: string = formatMessage({id: "message.common.loading"});
    finishText: string = formatMessage({id: "message.common.listNoMore"});
    listErrorText: string = formatMessage({id: "message.common.listError"});

    dataList: ArchivesInfo[] = [];

    created() {
        
    }

    mounted() {
        
    }

    fetchList() {
        this.listLoading = true;
        this.listLoadError = false;
        let lThis:any = this;
        lThis.$http.getArchivesList(1, this.pageNo, this.pageSize, (errorInfo: ErrorInfo, data: ArchivesList) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                this.errorMsg = errorInfo.msg;
                this.listLoadError = true;
            } else {
                data && data.list.forEach(item => {
                    // 去重 
                    let exist: boolean = false;
                    for (let n = 0; n < this.dataList.length; n++) {
                        if (this.dataList[n].id === item.id) {
                            exist = true;
                            break;
                        }
                    }

                    if (!exist) {
                        this.dataList.push(item);
                    }
                });

                this.pageNo = this.pageNo + 1;

                if (data && this.pageNo > data.pagination.totalPage) {
                    this.listFinished = true;
                }
            }

            this.listLoading = false;
    
        });
    }
}
